import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import { Form, Text } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'
import FloorsBlocksContainers from './FloorsBlocksContainers'
import { mutation } from '../../helpers'

import { StyledProjectInfo, StyledFloorsBlock } from './styled'

const ProjectForm = (props) => {
	const { mutations: { update: { rawUpdateProject } } } = props
	const { currentProjectData, currentProjectIds } = useContext(RestaurantContext)
	const [updateProject] = useMutation(rawUpdateProject)
	const [t] = useTranslation()

	const handleProjectCaption = ({ caption }) => {
		if(caption && caption !== currentProjectData.projectData.caption) {
			return mutation(updateProject, {
				fields: {
					id: currentProjectIds.projectId,
					caption: caption
				}
			})
		}
	}

	return (
		<div style={{ position: 'relative' }}>
			<p>
				{currentProjectData.projectData.caption}
			</p>

			<ContentBlock label={t('restaurant_designer_section.strings.project_form_title')} >
				<Form
					key={currentProjectIds.floorId}
					smartSubmit
					onSubmit={(fields)=>handleProjectCaption(fields)}
					initialValues={{
						caption: currentProjectData.projectData.caption
					}} render={() => (
						<StyledProjectInfo>
							<Text
								field={'caption'}
								label={t('restaurant_designer_section.fields.project_input_label')}
								style={{ marginBottom: '20px' }}
							/>
						</StyledProjectInfo>
					)}
				/>

				<StyledFloorsBlock>
					<FloorsBlocksContainers {...props} />
				</StyledFloorsBlock>

			</ContentBlock>
		</div>

	)
}

export default ProjectForm
